


export function renderSanitation(doc, sfdBase64, feacalSludgeBase64, solidWasteBase64, containmentOutletBase64, lastY) {

    let y = lastY;
    

    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Shit Flow Diagram", 14, y);
    y += 10;
    
    if (sfdBase64) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const imgWidth = 180;
        const imgHeight = 90;
        const x = (pageWidth - imgWidth) / 2;
        doc.addImage(sfdBase64, "PNG", x, y, imgWidth, imgHeight);
    }

    doc.addPage();
    y = 30;


    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Faecal Sludge Life Cycle", 14, y);
    y += 10;
    
    if (feacalSludgeBase64) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const imgWidth = 180;
        const imgHeight = 90;
        const x = (pageWidth - imgWidth) / 2;
        doc.addImage(feacalSludgeBase64, "PNG", x, y, imgWidth, imgHeight);
        y += imgHeight + 15; 
    }

  
    y += 10; 
    
    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Containment Outlet Behaviour", 14, y);
    y += 10; 

    if (containmentOutletBase64) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const imgWidth = 180;
        const imgHeight = 90;
        const x = (pageWidth - imgWidth) / 2;
        doc.addImage(containmentOutletBase64, "PNG", x, y, imgWidth, imgHeight);
        y += imgHeight + 15; 
    }


    doc.addPage();
    y = 30;


    doc.setFontSize(13);
    doc.setTextColor(40, 40, 100);
    doc.text("Solid Waste Life Cycle", 14, y);
    y += 10;

    if (solidWasteBase64) {
        const pageWidth = doc.internal.pageSize.getWidth();
        const imgWidth = 180;
        const imgHeight = 90;
        const x = (pageWidth - imgWidth) / 2;
        doc.addImage(solidWasteBase64, "PNG", x, y, imgWidth, imgHeight);
       // y += imgHeight + 15;
    }

    

    return y;



}
